import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

import AssureContext from '../context/assure-context';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '80%',
    paddingLeft: theme.spacing(2),
  },
}));

function valuetext(value) {
  return `${value}DZD`;
}

export default function PriceRangeSlider() {
  const classes = useStyles();
  const context = useContext(AssureContext);

  const handleChange = (event, newValue) => {
    context.setPriceRange(newValue);
    context.addSearchResult();
  };

  return (
    <div className={classes.root}>
      <br />
      <Slider
        value={context.priceRange}
        onChange={handleChange}
        aria-labelledby="range-slider"
        getAriaValueText={valuetext}
        valueLabelDisplay="on"
      />
      <Typography id="range-slider" gutterBottom>
        Price range
      </Typography>
    </div>
  );
}
